<form [formGroup]="questionCategoryForm" (ngSubmit)="saveQuestionCategory(inProgress)">
    <div class=" modal-header">
        <h5 class="modal-title d-flex align-items-center">
            <i class="bx bx-category me-1 font-20 text-primary"></i>{{questionCategoryForm.value.id?'Update':'Add'}}
            Question Category
        </h5>
        <button type="button" class="btn-close text-end" data-bs-dismiss="modal" aria-label="Close"
            (click)="activeModal.close('Close')"></button>
    </div>
    <div class="modal-body">
        <div class="row g-3 mb-2">
            <div class="col-md-6">
                <label for="name" class="form-label">Name <b class="text-secondary">*</b></label>
                <div class="input-group">
                    <span class="input-group-text bg-transparent border-end-0"><i class='bx bxs-user'></i></span>
                    <input type="text" class="form-control" id="name" formControlName="name" ngbAutofocus
                        [ngClass]="{'is-invalid': submitted && f.name.errors}" placeholder="Enter Name" />
                    <div class="invalid-feedback" *ngIf="submitted && f.name.errors">
                        <span *ngIf="f.name.errors.required">Course name is required.</span>
                        <span *ngIf="f.name.errors.pattern">Course name must be 1-250 chars.</span>
                    </div>
                </div>
            </div>
            <div class="col-md-6">
                <label for="label" class="form-label">Description</label>
                <div class="input-group">
                    <span class="input-group-text bg-transparent border-end-0"><i class='bx bxs-file'></i></span>
                    <textarea class="form-control" id="label" formControlName="label"  cols="1" rows="1"
                        [ngClass]="{'is-invalid': submitted && f.label.errors}" placeholder="Enter Description"
                        ></textarea>
                    <div class="invalid-feedback" *ngIf="submitted && f.label.errors">
                        <span *ngIf="f.label.errors.required">Description is required.</span>
                        <span *ngIf="f.label.errors.pattern">Description must be 1-250 chars.</span>
                    </div>
                </div>
            </div>
            <div class="col-md-6">
                <label for="note" class="form-label">Notes</label>
                <div class="input-group">
                    <span class="input-group-text bg-transparent border-end-0"><i class='bx bx-note'></i></span>
                    <textarea class="form-control" id="note" formControlName="notes"  cols="1" rows="1"
                        [ngClass]="{'is-invalid': submitted && f.notes.errors}" placeholder="Enter Note"
                        ></textarea>
                    <div class="invalid-feedback" *ngIf="submitted && f.notes.errors">
                        <span *ngIf="f.notes.errors.required">Notes is required.</span>
                        <span *ngIf="f.notes.errors.pattern">Notes must be 1-250 chars.</span>
                    </div>
                </div>
            </div>
            <div class="col-md-4">
                <label for="status" class="form-label">Status<b class="text-secondary">*</b></label>
                <div class="input-group">
                  <span class="input-group-text bg-transparent border-end-0">
                    <i class="bx bxs-layer"></i>
                  </span>
                  <ng-select class="form-control rcx-ng-select"
                             formControlName="approvalStatus"
                             placeholder="Select Status"
                             [ngClass]="{'is-invalid': submitted && f.approvalStatus.errors}">
                    <ng-template ng-option-tmp let-status="item">
                      <span [class]="getBadgeClassForStatus(status)">
                        {{ formatStatus(status) }}
                      </span>
                    </ng-template>
                    <ng-template ng-label-tmp let-status="item">
                      <span [class]="getBadgeClassForStatus(status)">
                        {{ formatStatus(status) }}
                      </span>
                    </ng-template>
                    <ng-option *ngFor="let status of statuses" [value]="status"></ng-option>
                  </ng-select>
                  <div class="invalid-feedback" *ngIf="submitted && f.approvalStatus.errors">
                    <span *ngIf="f.approvalStatus.errors.required">Please select a status.</span>
                  </div>
                </div>
              </div>              
            <div class="col-md-auto">
                <div class="form-check">
                    <input class="form-check-input" type="checkbox" id="disabled" formControlName="disabled">
                    <label class="form-check-label" for="disabled">Disabled</label>
                </div>
            </div>
            <div class="col-lg-auto ms-auto mt-4">
                <button type="submit" class="btn btn-secondary rcx-btn" #inProgress
                    [ngClass]="{'no-event':inProgress?.value=='true'}">
                    <ng-container *ngIf="inProgress?.value=='true'">
                        <span class="spinner-border spinner-border-sm" role="status" aria-hidden="true"></span>
                        {{questionCategoryForm.value.id?'Updating...':'Saving...'}}
                    </ng-container>
                    <ng-container *ngIf="inProgress?.value!='true'">
                        <i class="bx bx-save"></i>{{questionCategoryForm.value.id?'Save Changes':'Save'}}
                    </ng-container>
                </button>
            </div>
        </div>
    </div>
</form>